import { render, staticRenderFns } from "./incluirAulaDialog.vue?vue&type=template&id=ab5e7022&scoped=true"
import script from "./incluirAulaDialog.vue?vue&type=script&lang=js"
export * from "./incluirAulaDialog.vue?vue&type=script&lang=js"
import style0 from "./incluirAulaDialog.vue?vue&type=style&index=0&id=ab5e7022&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab5e7022",
  null
  
)

export default component.exports